import {useHistory} from 'react-router-dom'
import {useColorVariation} from '../../hooks'
import Swatch from '../swatch-group/swatch'
import {Box, HStack, SkeletonCircle} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import SwatchGroup from '../swatch-group'

export const Skeleton = () => {
    return (
        <HStack>
            <SkeletonCircle size={12} />
            <SkeletonCircle size={12} />
            <SkeletonCircle size={12} />
            <SkeletonCircle size={12} />
        </HStack>
    )
}

const ColorVariationSelection = ({
    product,
    loading,
    onChange,
    isProductASet,
    onHoverChange,
    labelPrefix
}) => {
    const history = useHistory()

    const colorVariation = useColorVariation(product, isProductASet)

    if (!colorVariation?.values?.length) {
        return null
    }

    return (
        <SwatchGroup
            loading={loading}
            onChange={(value, href) => {
                if (!href) return
                history.replace(href)
                onChange?.(value, href)
            }}
            value={colorVariation.selectedValue.value}
            label={labelPrefix ? labelPrefix + ' ' + colorVariation.name : colorVariation.name}
            displayName={colorVariation.selectedValue.name}
            spacing={2}
        >
            {!loading ? (
                colorVariation.values.map(({href, name, image, value, orderable, productId}) => (
                    <Swatch
                        key={value}
                        href={href}
                        disabled={!orderable}
                        value={value}
                        name={name}
                        className="variation"
                        onMouseEnter={() => {
                            onHoverChange?.({
                                currentId: product.id,
                                hoveredId: productId
                            })
                        }}
                        onMouseLeave={() => {
                            onHoverChange?.()
                        }}
                    >
                        {image ? (
                            <Box
                                height="100%"
                                width="100%"
                                minWidth="32px"
                                minHeight="32px"
                                backgroundRepeat="no-repeat"
                                backgroundSize="cover"
                                backgroundColor={name.toLowerCase()}
                                backgroundImage={
                                    image
                                        ? `url("${encodeURI(image.disBaseLink || image.link)}")`
                                        : ''
                                }
                                className="variation"
                            />
                        ) : (
                            name
                        )}
                    </Swatch>
                ))
            ) : (
                <Skeleton />
            )}
        </SwatchGroup>
    )
}

ColorVariationSelection.propTypes = {
    product: PropTypes.object,
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    isProductASet: PropTypes.bool,
    onHoverChange: PropTypes.func,
    labelPrefix: PropTypes.string
}

export default ColorVariationSelection
